module.exports = __webpack_public_path__ + "img/tile-05.8a63431c.png";